import { apiFetch } from "@/shared/api/http";

export interface StudentMomentMedia {
  momentoId: string;
  midiaId: string;
  contentType: string;
  ordem: number;
}

export interface StudentMoment {
  id: string;
  tipoOrigem: "Aula" | "Competicao" | string;
  origemId: string;
  sessaoId?: string | null;
  turmaId?: string | null;
  titulo: string;
  modalidade: string;
  data: string;
  horaInicio?: string | null;
  totalInscritos?: number | null;
  legenda?: string | null;
  publicadoEmUtc: string;
  midias: StudentMomentMedia[];
}

export function fetchStudentMoments(take = 30) {
  return apiFetch<StudentMoment[]>(`/api/app/aluno/momentos?take=${Math.max(1, Math.min(60, take))}`);
}

export function studentMomentMediaPath(momentoId: string, midiaId: string) {
  return `/api/app/aluno/momentos/${momentoId}/midias/${midiaId}`;
}
